var ls = typeof localStorage === 'object' ? {
    set: function(key, value) {
        try {
            value = JSON.stringify(value);
        } catch (err) {
            console.warn(err);
        }
        try {
            localStorage.setItem(key, value);
        } catch (err1) {
            console.warn(err1);
        }
    },
    get: function(key) {
        var value;
        try {
            value = localStorage.getItem(key);
        } catch (err) {
            console.warn(err);
        }
        try {
            value = JSON.parse(value);
        } catch (err2) {
            console.warn(err2);
        }
        return value;
    },
    remove: function(key) {
        try {
            localStorage.removeItem(key);
        } catch (err) {
            console.warn(err);
        }
    }
} : {
    set: function() {
    },
    get: function() {
    },
    remove: function() {
    }
};
export default ls;
